define([
	"dojo/_base/declare",
	"Apparel/StructureItemSwitchboard",
	"BusinessPlanning/SwitchboardMixin"
], function(declare,StructureItemSwitchboard,SwitchboardMixin) {

	return declare([StructureItemSwitchboard, SwitchboardMixin], {
		_getStoreOptions: function(/*String*/url, /*Relationship?*/r) {
			// summary: apply filter to view and remove any actions to add or remove items
			this.groupFilter = this._resolveViewRelation(this.actionToolbar.view);
			return this.inherited(arguments);
		}
	});
});